// RDIIForm.jsx
import { useState, useEffect } from "react"
import { UniversalDropDown } from "@fileops/swmm-react"
import { Button } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * RDII Form is a group of data inputs usually shown when clicking on Node->Inflows. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @param {string} target The name of the object targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function RDIIForm({model, setModel, fullModel, target}) {
  const [uhGroups]   = useState([...(Object.keys(fullModel.HYDROGRAPHS).length===0?[]:Object.keys(fullModel.HYDROGRAPHS))])
  const [sewerArea, setSewerArea] = useState(0)
  const [uhGroup, setUHgroup]     = useState('')

  useEffect(()=>{
    // If there is no RDII record for this target, create one
    if(model && model.RDII){
      if(!([target] in model.RDII)){
        setModel(prev => ({
          ...prev,
          RDII:{
            ...prev.RDII,
            [target]: {
                SewerArea: "0",
                UHgroup: '',
            }
          }
        }))
        setSewerArea(0)
        setUHgroup('')
      } else {
        setSewerArea(model.RDII[target].SewerArea)
        setUHgroup(model.RDII[target].UHgroup)
      }
    }
  }, )

  const updateSewerArea = (val) => {
    setSewerArea(val)
    if(model && model.RDII){
      setModel(prev => ({
        ...prev,
        RDII:{
          ...prev.RDII,
          [target]: {
            ...prev.RDII[target],
            SewerArea: val
          }
        }
      }))
    }
  }

  const updateUHgroup = (val) => {
    if(model && model.RDII){
      setModel(prev => ({
        ...prev,
        RDII:{
          ...prev.RDII,
          [target]: {
            ...prev.RDII[target],
            UHgroup: val
          }
        }
      }))
    }
  }


  return(
    <>
    {
      <>
        {(
          target && 
          target.length > 0 && 
          <label className='editor-small' >Sewer Area
            <input  type = "text"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateSewerArea(e.target.value)}}
                    value={sewerArea}
                    id={'SewerArea_'+target}
            />
          </label>
        )}
        {(
          target && 
          target.length > 0 && 
          <label className='editor-small' >Unit Hydrograph Group
            <Button style={{padding: '0px', float:'right', display:'inline' }}  onClick={()=>{updateUHgroup("")}}>CLEAR</Button>
            <UniversalDropDown style={{padding: '0'}}
              IDs={uhGroups} 
              selectText={"Select a UH Group"} 
              value={uhGroup}
              onChange={(val)=>{updateUHgroup(val)}} >
            </UniversalDropDown>
          </label>
        )}
      </>
    }
    </>
  )
}